const WHATSAPP_CONSTANTS = {
  GET_WHATSAPP_MESSAGE_REQUEST: 'GET_WHATSAPP_MESSAGE_REQUEST',
  GET_WHATSAPP_MESSAGE_SUCCESS: 'GET_WHATSAPP_MESSAGE_SUCCESS',
  GET_WHATSAPP_MESSAGE_FAIL: 'GET_WHATSAPP_MESSAGE_FAIL',
  
  UPDATE_WHATSAPP_MESSAGE_REQUEST: 'UPDATE_WHATSAPP_MESSAGE_REQUEST',
  UPDATE_WHATSAPP_MESSAGE_SUCCESS: 'UPDATE_WHATSAPP_MESSAGE_SUCCESS',
  UPDATE_WHATSAPP_MESSAGE_FAIL: 'UPDATE_WHATSAPP_MESSAGE_FAIL',
  UPDATE_WHATSAPP_MESSAGE_RESET: 'UPDATE_WHATSAPP_MESSAGE_RESET',
}

const ADMIN_NOTES_CONSTANTS = {
  GET_ADMIN_NOTES_REQUEST: 'GET_ADMIN_NOTES_REQUEST',
  GET_ADMIN_NOTES_SUCCESS: 'GET_ADMIN_NOTES_SUCCESS',
  GET_ADMIN_NOTES_FAIL: 'GET_ADMIN_NOTES_FAIL',
  
  UPDATE_ADMIN_NOTES_REQUEST: 'UPDATE_ADMIN_NOTES_REQUEST',
  UPDATE_ADMIN_NOTES_SUCCESS: 'UPDATE_ADMIN_NOTES_SUCCESS',
  UPDATE_ADMIN_NOTES_FAIL: 'UPDATE_ADMIN_NOTES_FAIL',
  UPDATE_ADMIN_NOTES_RESET: 'UPDATE_ADMIN_NOTES_RESET',
}

export default WHATSAPP_CONSTANTS
export { ADMIN_NOTES_CONSTANTS }